import { BrowserRouter, Routes, Route } from 'react-router-dom';

import ScrollToTop from './components/scrollToTop/scrollToTop';
import Hero from './components/hero/hero';
import Home from './components/home/home';
import Projects from './components/projects/projects';
import ProjectDetailsCard from './components/projects/projectDetailsCard/projectDetailsCard';
import Footer from './components/footer/footer';
import About from './components/about/about';
import Services from './components/services/services';
import CtaFooter from './components/ctaFooter/ctaFooter';
import Contacts from './components/contacts/contacts';

function App() {

  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <div className="App">

        <Hero />

        <ScrollToTop />

        <Routes>

          <Route path="/"
            element={

              <Home />

            }
          />

          <Route path="/home"
            element={

              <Home />

            }
          />

          <Route path="/about"
            element={
              <About />
            }
          />

          <Route path="/projects"
            element={
              <Projects />
            }
          />

          <Route path="/projects/:projectname"
            element={
              <ProjectDetailsCard />
            }
          />

          <Route path="/services"
            element={
              <Services />
            }
          />

          <Route path="/contacts"
            element={
              <Contacts />
            }
          />

          <Route path="*"
            element={
              <CtaFooter />
            }
          />

        </Routes>

        <Footer />

      </div>

    </BrowserRouter>
  );
}

export default App;

